import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./i18n";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Admin from "./pages/Admin";
import ConsentBanner from "./consent/ConsentBanner";
import FloatingCallButton from "./components/FloatingCallButton";

const ADMIN_HASH = "#34DQKMme41";

// Optional tiny debug banner. Set ?debug=1 in the URL to show it.
function DebugBar({ page }) {
  const [on, setOn] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setOn(params.get("debug") === "1");
  }, []);
  if (!on) return null;
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        background: "rgba(17,24,39,0.9)",
        color: "white",
        fontSize: 12,
        padding: "6px 10px",
        zIndex: 1000,
      }}
    >
      hash: <b>{window.location.hash || "(none)"}</b> | page: <b>{page}</b>
    </div>
  );
}

export default function App() {
  const [page, setPage] = useState("home");
  const { t, i18n } = useTranslation("common");

  useEffect(() => {
    const url = new URL(window.location.href);
    const normalized = i18n.language?.startsWith("en") ? "en" : "ro";
    if (url.searchParams.get("lng") !== normalized) {
      url.searchParams.set("lng", normalized);
      window.history.replaceState({}, "", url.toString());
    }
  }, [i18n.language]);

  // HASH ROUTING (runs on mount + when hash changes)
  useEffect(() => {
    const applyHash = () => {
      const { hash } = window.location;
      if (hash === ADMIN_HASH) {
        setPage("admin");
      } else if (hash === "#gallery") {
        setPage("gallery");
      } else {
        setPage("home");
      }
    };
    applyHash();
    window.addEventListener("hashchange", applyHash);
    return () => window.removeEventListener("hashchange", applyHash);
  }, []);

  // SCROLL TO TOP (never clears the admin hash)
  useEffect(() => {
    setTimeout(() => {
      const { hash } = window.location;
      if (hash && hash !== ADMIN_HASH) {
        window.history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search
        );
      }
      window.scrollTo({ top: 0, behavior: "auto" });
    }, 0);
  }, [page, i18n.language]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 text-gray-900">
      <Navbar page={page} setPage={setPage} />
      {page === "home" && <Home setPage={setPage} />}
      {page === "gallery" && <Gallery setPage={setPage} />}
      {page === "admin" && <Admin />}
      <ConsentBanner />
      <footer className="border-t bg-white/60">
        <div className="max-w-6xl mx-auto px-4 py-6 text-sm text-gray-600 flex flex-col sm:flex-row gap-2 sm:gap-4 items-center justify-between">
          <span>© {new Date().getFullYear()} Demo</span>
          <span className="opacity-80">{t("footer.location")}</span>
        </div>
      </footer>
<FloatingCallButton phone="+40000000000" label="Sună acum" />
      <DebugBar page={page} />
    </div>
  );
}
